import { render, staticRenderFns } from "./ContactTagSelectMenu.vue?vue&type=template&id=1fd64654&scoped=true&"
import script from "./ContactTagSelectMenu.vue?vue&type=script&lang=js&"
export * from "./ContactTagSelectMenu.vue?vue&type=script&lang=js&"
import style0 from "./ContactTagSelectMenu.vue?vue&type=style&index=0&id=1fd64654&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd64654",
  null
  
)

export default component.exports